import { format } from 'date-fns'

export default function(api: GlobalFetch) {
  return async function(calendarId: number, selectedDay) {
    await api.fetch(`/api/v2/calendar/delday`, {
      body: JSON.stringify({
        days: [format(selectedDay, 'YYYY-MM-DD')],
        // eslint-disable-next-line @typescript-eslint/camelcase
        id_calendar: calendarId,
      }),
      method: 'POST',
    })
  }
}
